import { GlossaryCategoriesDocument, GlossaryCategoryFragment } from '@/generated/contentful'

import { client as contentful } from '@/lib/contentful/client'

import { getErrorMessage } from '@/utils/error/getErrorMessage'
import { isNonNullable } from '@/utils/isNonNullable'

export async function getGlossaryCategories(
	pageSkip = 0,
	itemLimit = 100,
	locale = 'en-US',
	entries: GlossaryCategoryFragment[] = []
): Promise<GlossaryCategoryFragment[]> {
	try {
		const { categoryCollection } = await contentful().request(GlossaryCategoriesDocument, {
			locale,
			limit: itemLimit,
			skip: pageSkip,
			where: { slug_exists: true }
		})

		if (!categoryCollection?.items.length) return entries

		const { skip, limit, total, items } = categoryCollection ?? {}

		entries.push(...items.filter(isNonNullable))

		if (total > pageSkip) {
			return entries
				.concat(await getGlossaryCategories(skip + itemLimit, limit, locale))
				?.filter((item) => item?.linkedFrom?.glossaryCollection?.total !== 0)
		}
	} catch (e) {
		const message = getErrorMessage(e)

		console.error(message)
	}

	return entries?.filter((item) => item?.linkedFrom?.glossaryCollection?.total !== 0)
}
